import { render } from "./LoginAllInOne.vue?vue&type=template&id=5b83ea36"
import script from "./LoginAllInOne.vue?vue&type=script&lang=js"
export * from "./LoginAllInOne.vue?vue&type=script&lang=js"

import "./LoginAllInOne.vue?vue&type=style&index=0&id=5b83ea36&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__